import { useContext } from 'react';
import { HeaderHeightContext } from '../contexts/HeaderHeightContext';

// TODO- this needs to be reworked , not working correctly
export default function useHeaderHeight() {
  const { headerHeight } = useContext(HeaderHeightContext);

  return headerHeight;
}
